const MuiList = {
    styleOverrides: {
        root: {
            paddingTop: 0,
            paddingBottom: 0,
            '&.table-list': {
                '& .MuiListItem-root': {
                    paddingTop: 4,
                    paddingBottom: 4,
                },
                '& .MuiListItemText-root': {
                    margin: 0,
                },
            },
            '&.nav-list': {
                '& .MuiListItem-root': {
                    paddingTop: 7,
                    paddingBottom: 7,
                },
                '& .MuiListItemText-root': {
                    margin: 0,
                },
            },
            '& .Mui-selected': {
                fontWeight: 700,
            },
        },
        padding: {
            paddingTop: 0,
            paddingBottom: 0,
        },
    },
};
export default MuiList;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTXVpTGlzdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb25maWcvY29tcG9uZW50cy9NdWlMaXN0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLE1BQU0sT0FBTyxHQUFpQztJQUM1QyxjQUFjLEVBQUU7UUFDZCxJQUFJLEVBQUU7WUFDSixVQUFVLEVBQUUsQ0FBQztZQUNiLGFBQWEsRUFBRSxDQUFDO1lBQ2hCLGNBQWMsRUFBRTtnQkFDZCxxQkFBcUIsRUFBRTtvQkFDckIsVUFBVSxFQUFFLENBQUM7b0JBQ2IsYUFBYSxFQUFFLENBQUM7aUJBQ2pCO2dCQUNELHlCQUF5QixFQUFFO29CQUN6QixNQUFNLEVBQUUsQ0FBQztpQkFDVjthQUNGO1lBQ0QsWUFBWSxFQUFFO2dCQUNaLHFCQUFxQixFQUFFO29CQUNyQixVQUFVLEVBQUUsQ0FBQztvQkFDYixhQUFhLEVBQUUsQ0FBQztpQkFDakI7Z0JBQ0QseUJBQXlCLEVBQUU7b0JBQ3pCLE1BQU0sRUFBRSxDQUFDO2lCQUNWO2FBQ0Y7WUFDRCxpQkFBaUIsRUFBRTtnQkFDakIsVUFBVSxFQUFFLEdBQUc7YUFDaEI7U0FDRjtRQUNELE9BQU8sRUFBRTtZQUNQLFVBQVUsRUFBRSxDQUFDO1lBQ2IsYUFBYSxFQUFFLENBQUM7U0FDakI7S0FDRjtDQUNGLENBQUM7QUFFRixlQUFlLE9BQU8sQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IENvbXBvbmVudHMsIFRoZW1lIH0gZnJvbSAnQG11aS9tYXRlcmlhbCc7XG5cbmNvbnN0IE11aUxpc3Q6IENvbXBvbmVudHM8VGhlbWU+WydNdWlMaXN0J10gPSB7XG4gIHN0eWxlT3ZlcnJpZGVzOiB7XG4gICAgcm9vdDoge1xuICAgICAgcGFkZGluZ1RvcDogMCxcbiAgICAgIHBhZGRpbmdCb3R0b206IDAsXG4gICAgICAnJi50YWJsZS1saXN0Jzoge1xuICAgICAgICAnJiAuTXVpTGlzdEl0ZW0tcm9vdCc6IHtcbiAgICAgICAgICBwYWRkaW5nVG9wOiA0LFxuICAgICAgICAgIHBhZGRpbmdCb3R0b206IDQsXG4gICAgICAgIH0sXG4gICAgICAgICcmIC5NdWlMaXN0SXRlbVRleHQtcm9vdCc6IHtcbiAgICAgICAgICBtYXJnaW46IDAsXG4gICAgICAgIH0sXG4gICAgICB9LFxuICAgICAgJyYubmF2LWxpc3QnOiB7XG4gICAgICAgICcmIC5NdWlMaXN0SXRlbS1yb290Jzoge1xuICAgICAgICAgIHBhZGRpbmdUb3A6IDcsXG4gICAgICAgICAgcGFkZGluZ0JvdHRvbTogNyxcbiAgICAgICAgfSxcbiAgICAgICAgJyYgLk11aUxpc3RJdGVtVGV4dC1yb290Jzoge1xuICAgICAgICAgIG1hcmdpbjogMCxcbiAgICAgICAgfSxcbiAgICAgIH0sXG4gICAgICAnJiAuTXVpLXNlbGVjdGVkJzoge1xuICAgICAgICBmb250V2VpZ2h0OiA3MDAsXG4gICAgICB9LFxuICAgIH0sXG4gICAgcGFkZGluZzoge1xuICAgICAgcGFkZGluZ1RvcDogMCxcbiAgICAgIHBhZGRpbmdCb3R0b206IDAsXG4gICAgfSxcbiAgfSxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IE11aUxpc3Q7XG4iXX0=